// URL Constants
export const version = "/api/v1/";

const companyBase = `${version}company/`;
const accountManagerBase = `${version}account_manager/`;
const accountAdminBase = `${version}account_admin/`;
const supportUserBase = `${version}support_user/`;
const supportUserTicketBase = `${version}user_support/ticket/`;
const supportBase = `${version}ticket/`;
const branchBase = `${version}branch/`;
const driverBase = `${version}driver/`;
const vehicleBase = `${version}vehicle/`;
const warehouseBase = `${version}warehouse/`;
const integrationPartnerBase = `${version}webhook/integration_partner/`;
const customerBase = `${version}customer/`;
const customerAddressBase = `${version}customer_address/`;
const itemBase = `${version}item/`;
const itemUnitBase = `${version}item_unit/`;
const orderBase = `${version}order/`;
const adhocOrderBase = `${version}adhoc/order/`;
const adhocDeliveryOrderBase = `${version}adhoc/delivery_order/`;
const adhocPickupOrderBase = `${version}adhoc/pickup_order/`;
const saleOrderBase = `${version}sale/order/`;
const saleDeliveryOrderBase = `${version}sale/delivery_order/`;
const salePickupOrderBase = `${version}sale/pickup_order/`;
const paymentMethodBase = `${version}payment_method/`;
const normalUserBase = `${version}normal_user/`;
const consigneeUserBase = `${version}consignee_user/`;
const consigneeBase = `${version}consignee/`;
export const profileBase = `${version}user/`;
const tripBase = `${version}trip/`;
const tripExpenseBase = `${version}trip_expense/`;
const tripPlanningBase = `${version}trip_plan/`;
const plannedTripBase = `${version}planned_trip/`;
const tripPlanningTemplateBase = `${version}planning_template/`;
const regionRestrictionBase = `${version}region_restriction/`;
const driverZoneBase = `${version}driver_zone/`;
const old_operations = `${version}operations/`;
const new_operations = `${version}operations/`;
const userNotificationBase = `${version}notification/`;
const countryBase = `${version}country/`;
const moduleBase = `${version}module/`;
const moduleKeyWordBase = `${version}module_key_word/`;
const fieldConfigurationBase = `${version}field_configuration/`;
const tagBase = `${version}tag/`;
const subscriptionBase = `${version}subscription/`;
const roleBase = `${version}role/`;
const vehicleTagsBase = `${version}vehicle_tag/`;
const customerAddressTagsBase = `${version}customer_address_tags/`;
const vehicleDocumentsBase = `${version}vehicle_document/`;
const driverDocumentsBase = `${version}driver_document/`;
const clientDashboardBase = `${version}dashboard/client/`;
const systemAdminDashboardBase = `${version}dashboard/admin/`;
const reportsBase = `${version}report/`;
const themeBase = `${version}theme/`;
const orderNewBase = `${version}order-new/`;
const orderTrackingBase = `${version}order_tracking/`;
const integrationLogBase = `${version}integrationLogs/`;
const resetPasswordBase = `${version}reset_password/`;
const projectBase = `${version}project/`;
const customerLocationUpdateBase = `${version}customer_location_update_logs/`;
const currencyBase = `${version}currency/`;
const announcementBase = `${version}announcement/`;
const customFieldBase = `${version}custom_fields/`;
const vehicleTypeBase = `${version}vehicle_type/`;
const licenseTypeBase = `${version}license_type/`;
const permitTypeBase = `${version}permit_type/`;
const apiTokenBase = `${version}api_key/`;
const telematicsVendorBase = `${version}telematics_vendor/`;
const storageTypeBase = `${version}storage_type_master/`;
const resendOTP = `${version}app/order`;

export const storageType = {
  base: storageTypeBase,
  select: `${storageTypeBase}select/`,
};
export const vehicleType = {
  base: vehicleTypeBase,
};

export const resendOTPToCustomer = {
  base:resendOTP
}
export const licenseType = {
  base: licenseTypeBase,
};
export const permitType = {
  base: permitTypeBase,
};

export const announcement = {
  base: announcementBase,
  select: `${announcementBase}select/`,
};

export const company = {
  base: companyBase,
  select: `${companyBase}select/`,
};

export const accountManager = {
  base: accountManagerBase,
  select: `${accountManagerBase}select/`,
};

export const accountAdmin = {
  base: accountAdminBase,
  select: `${accountAdminBase}select/`,
};

export const branch = {
  base: branchBase,
  select: `${branchBase}select/`,
};

export const driver = {
  base: driverBase,
  select: `${driverBase}select/`,
  options: `${driverBase}options/`,
  document: `${version}driver_document/`,
  deleteZonesDriver: `${version}driver_zone/`,
};

export const vehicle = {
  base: vehicleBase,
  select: `${vehicleBase}select/`,
  options: `${vehicleBase}options/`,
  document: `${version}vehicle_document/`,
};

export const warehouse = {
  base: warehouseBase,
  select: `${warehouseBase}select/`,
};

export const integrationPartner = {
  base:integrationPartnerBase
}

export const customer = {
  base: customerBase,
  select: `${customerBase}select/`,
};

export const customerLocationUpdate = {
  base: customerLocationUpdateBase,
};

export const customerAddress = {
  base: customerAddressBase,
  select: `${customerAddressBase}select/`,
};

export const item = {
  base: itemBase,
  select: `${itemBase}select/`,
  options: `${itemBase}options/`,
};

export const itemUnit = {
  base: itemUnitBase,
  select: `${itemUnitBase}select/`,
};

export const paymentMethod = {
  base: paymentMethodBase,
  select: `${paymentMethodBase}select/`,
  options: `${paymentMethodBase}options/`,
};

export const order = {
  base: orderBase,
  options: `${saleOrderBase}options/`,
  saleOrderDownload: `${saleOrderBase}download_orders_sheet/`,
  saleOrderItemDownload: `${saleOrderBase}download_orders_items_sheet/`,
  adhocOrderDownload: `${adhocOrderBase}download_orders_sheet/`,
  adhocOrderItemDownload: `${adhocOrderBase}download_orders_items_sheet/`,
};

export const orderNew = {
  base: orderNewBase,
};

export const orderTracking = {
  base: orderTrackingBase,
};

export const orderItem = {
  base: "/api/v1/order_items/",
};

export const orderAttachment = {
  base: "/api/v1/order_attachment/",
};

export const saleOrder = {
  base: saleOrderBase,
  reschedule: `${saleOrderBase}reschedule_orders/`,
  cancel: `${saleOrderBase}cancelled_orders/`,
  deliveryOrderBase: saleDeliveryOrderBase,
  pickupOrderBase: salePickupOrderBase,
  select: `${saleOrderBase}select/`,
};

export const adhocOrder = {
  base: adhocOrderBase,
  reschedule: `${adhocOrderBase}reschedule_orders/`,
  cancel: `${adhocOrderBase}cancelled_orders/`,
  deliveryOrderBase: adhocDeliveryOrderBase,
  pickupOrderBase: adhocPickupOrderBase,
  select: `${adhocOrderBase}select/`,
};

export const normalUser = {
  base: normalUserBase,
  select: `${normalUserBase}select/`,
};
export const consignee = {
  base: consigneeBase,
  select: `${consigneeBase}select/`,
  order: `${consigneeBase}order/`,
  trip: `${consigneeBase}trip/`,
};
export const consigneeUser = {
  base: consigneeUserBase,
};

export const profile = {
  base: `${profileBase}profile/`,
  changePassword: `${profileBase}change_password/`,
  updateBranch: `${profileBase}update_preferred_branch/`,
  getCompanyConfiguration: `${profileBase}change_company_configuration/`,
  updateCompanyConfiguration: `${profileBase}change_company_configuration/`,
};

export const tripExpense = {
  base: `${tripExpenseBase}`,
};
export const trip = {
  base: `${tripBase}`,
  options: `${tripBase}options/`,
  reschedule: `${tripBase}reschedule_trip/`,
  cancel: `${tripBase}cancel_trip/`,
};

export const tripPlanning = {
  base: `${tripPlanningBase}`,
  options: `${tripPlanningBase}options/`,
};

export const plannedTrip = {
  base: `${plannedTripBase}`,
};

export const tripPlanningTemplate = {
  base: `${tripPlanningTemplateBase}`,
  options: `${tripPlanningTemplateBase}options/`,
};

export const regionRestriction = {
  base: `${regionRestrictionBase}`,
  remainingRegions: `${regionRestrictionBase}display_zones/`,
};

export const driverZone = {
  base: `${driverZoneBase}`,
  select: `${driverZoneBase}select/`,
  remainingZone: `${driverZoneBase}display_zones/`,
};

export const chat = {
  chatBase: `${version}chat/`,
  chatAttachment: `${version}chat/attachment/`,
};

export const operation = {
  operationBase: `${old_operations}`,
  driverOperation: `${old_operations}drivers/`,
  overviewOperation: `${old_operations}overview/`,
  tripRouteOperation: `${old_operations}trip_route/`,
};

export const newOperation = {
  operationBase: `${new_operations}`,
  tripAnalyticsOperation: `${old_operations}trip_analytics/`,
  tripStatsOperation: `${old_operations}trip_stats/`,
  fleetUtilizationOperation: `${old_operations}fleet_utilization/`,
  reasonUndeliveredOperation: `${old_operations}reason_for_unfinished_delivery/`,
  storageUtilizationOperation: `${old_operations}storage_utilization/`,
  orderStatusOperation: `${old_operations}order_stats/`,
  orderDeliveryVelocityOperation: `${old_operations}order_delivery_velocity/`,
  tripDelayOperation: `${old_operations}trip_delay/`,
  mapInfoOperation: `${old_operations}map_info/`,
  driverListOperation: `${old_operations}driver_list/`,
  tripDriverCountsOperation: `${old_operations}get_trip_counts/`,
  tripLogsOperation: "/api/v1/trip_logs/",
};

export const userNotification = {
  base: `${userNotificationBase}`,
};

export const country = {
  base: `${countryBase}`,
};

export const module = {
  base: `${moduleBase}`,
  keyWordbase: `${moduleKeyWordBase}`,
};

export const fieldConfiguration = {
  base: `${fieldConfigurationBase}`,
};

export const tag = {
  base: `${tagBase}`,
};
export const telematicsVendor = {
  base: `${telematicsVendorBase}`,
  select: `${telematicsVendorBase}select/`,
};
export const role = {
  base: `${roleBase}`,
};

export const vehicleTags = {
  base: `${vehicleTagsBase}`,
};

export const vehicleDocuments = {
  base: `${vehicleDocumentsBase}`,
};

export const driverDocuments = {
  base: `${driverDocumentsBase}`,
};

export const customerAddressTags = {
  base: `${customerAddressTagsBase}`,
};

export const theme = {
  base: `${themeBase}`,
};

export const subscription = {
  base: `${subscriptionBase}`,
  subscriptionLogs: `${version}subscription_logs/`,
};

export const logs = {
  vehicleLogsBase: `${version}vehicle_logs/`,
  driverLogsBase: `${version}driver_logs/`,
  customerAddressLogsBase: `${version}customer_address_logs/`,
  orderLogsBase: `${version}order_logs/`,
  tripLogsBase: `${version}trip_logs/`,
};

export const clientDashboard = {
  assetSummary: `${clientDashboardBase}summary/assets_summary/`,
  fleetUtilizationChart: `${clientDashboardBase}assets/fleet_utilization/`,
  assetUtilizationChart: `${clientDashboardBase}assets/asset_utilization/`,
  orderProcessingTimeChart: `${clientDashboardBase}orders/order_processing_time_vs_order_lead_time/`,
  orderReasonsChart: `${clientDashboardBase}orders/undelivered_top_reason/`,
  orderVsDeliveredChart: `${clientDashboardBase}orders/orders_vs_delivered/`,
  turnAroundTimeChart: `${clientDashboardBase}trips/turn_around_time/`,
  tripChart: `${clientDashboardBase}trips/created_vs_closed_trips/`,
  summaryStatistics: `${clientDashboardBase}summary/statistics/`,
  fleetUtilizationStatistics: `${clientDashboardBase}fleets/statistics/`,
  orderStatistics: `${clientDashboardBase}orders/statistics/`,
  tripStatistics: `${clientDashboardBase}trips/statistics/`,
  fleetCapacityUtilizationStatistics: `${clientDashboardBase}fleets_capacity_utilization/statistics/`,
};

export const systemAdminDashboard = {
  statistics: `${systemAdminDashboardBase}summary/`,
  subscriptionChart: `${systemAdminDashboardBase}subscription/`,
  companyOnboardingChart: `${systemAdminDashboardBase}onboarding/`,
  supportTicketChart: `${systemAdminDashboardBase}support_ticket/`,
};

export const integrationLogs = {
  base: `${integrationLogBase}`,
};

export const integration = {
  itemBase: `${version}integration/item_logs/`,
  orderBase: `${version}integration/order_logs/`,
  customerBase: `${version}integration/customer_logs/`,
  logsDetailsBase:`${version}integration/log_details/`
};

export const support = {
  base: supportBase,
  options: `${supportBase}options/`,
  document: `${version}ticket_attachment/`,
  comment: `${version}ticket_comment/`,
  logs: `${version}ticket_logs/`,
};

export const supportUser = {
  base: supportUserBase,
};

export const supportUserTicket = {
  base: supportUserTicketBase,
  options: `${supportUserTicketBase}options/`,
  document: `${version}ticket_attachment/`,
  comment: `${version}ticket_comment/`,
};
export const reports = {
  base: `${reportsBase}`,
  options: `${reportsBase}options/`,
  orderReports: `${reportsBase}order_report/`,
  dailyOrderReports: `${reportsBase}daily_order_report/`,
  tripReports: `${reportsBase}trip_report/`,
  vehicleReports: `${reportsBase}vehicle_report/`,
  vehicleKmReports: `${reportsBase}vehicle_km/`,
  vehicleOrderDeliveryReports: `${reportsBase}vehicle_order_delivery_report/`,
  vehicleOdometerReports: `${reportsBase}vehicle_odometer/`,
  driverAttendanceReports: `${reportsBase}driver_attendance_report/`,
  driverExpenseReports: `${reportsBase}driver_expense_report/`,
  driverTripReports: `${reportsBase}driver_trip_report/`,
  driverOrderDeliveryReports: `${reportsBase}driver_order_delivery_report/`,
  fleetUtilizationReport: `${reportsBase}fleet_utilization/`,
  operationSummaryReport: `${reportsBase}operation_summary_report/`,
};

export const resetPassword = {
  base: `${resetPasswordBase}`,
  verifyOTP: `${resetPasswordBase}verify/`,
};
export const project = {
  base: `${projectBase}`,
  select: `${projectBase}select/`,
};

export const currency = {
  base: `${currencyBase}`,
};

export const mobileApk = {
  base: "https://arcm.feroai.com/",
  latestApk: "https://arcm.feroai.com/api/v1/latest_apk/",
};

export const customFields = {
  base: customFieldBase,
  select: `${customFieldBase}select/`,
  options: `${customFieldBase}options/`,
};

export const apiToken = {
  base: apiTokenBase,
  regenerate: `${apiTokenBase}regenerate_key/`,
};
export const postmanUrl = {
  base: apiTokenBase,
  geturl: `${apiTokenBase}get_postman_url/`,
};
// Other Constants

export const driverAPK = {
  base: `${version}get_apk_url/`,
};